<template>
	<div class="profil">
		<div
			v-if="
				utilisateurExterneInfo.isDocteur &&
					utilisateurExterneInfo.executant &&
					utilisateurExterneInfo.executant.rpps
			"
		>
			N° RPPS : {{ utilisateurExterneInfo.executant.rpps }}
		</div>

		<div
			v-else-if="
				utilisateurExterneInfo.isStructure && utilisateurExterneInfo.numAm
			"
		>
			N° AM : {{ utilisateurExterneInfo.numAm }}
		</div>
		<div
			v-else-if="
				utilisateurExterneInfo.isDelegataire &&
					utilisateurExterneInfo.delegataire.numeroPrint
			"
		>
			{{ utilisateurExterneInfo.delegataire.numeroPrint }}
		</div>

		<div v-if="utilisateurExterneInfo.email">
			E-mail : {{ utilisateurExterneInfo.email }}
		</div>
	</div>
</template>

<script lang="ts">
	export default {
		props: {
			utilisateurExterneInfo: {
				type: Object,
				required: true
			}
		}
	};
</script>

<style lang="scss">
.profil {
  font-size: 0.875rem;
}
</style>
